import { ModuleFieldSuggestion } from './../components/elastic-global-search/models/module-search.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'globalSearchFieldFilter',
    pure: false
})

export class GlobalSearchFieldFilterPipe implements PipeTransform {

  transform(moduelSuggestions: ModuleFieldSuggestion[], searchValue: string): any {

        if(searchValue){
            return moduelSuggestions.filter(suggest=> suggest?.fieldName?.toLowerCase()?.includes(searchValue?.toLowerCase()));
        }

        return moduelSuggestions;
    }

 }
